import { Module } from 'vuex'
import actions from '@/store/user_management/actions'
import mutations from '@/store/user_management/mutations'
import { UserManagementStateInterface } from '@/models/store/UserManagementState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'

export const initState = (): UserManagementStateInterface => ({
  users: [],
  features: [],
  loading: false,
  saving: false
})

const userManagementModule: Module<
  UserManagementStateInterface,
  RootStateInterface
> = {
  namespaced: true,
  state: initState(),
  actions,
  mutations
}

export default userManagementModule
